import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

import ToggleButton from 'src/ui/ToggleButton/ToggleButton'
import CoachMark from 'src/ui/CoachMark/CoachMark'
import { t } from 'src/lib/i18n-react'

import TopicInfo from '../TopicInfo/TopicInfo'

const SPOTLIGHT_SX = {
  // add some padding around
  // use `px`
  marginTop: '-8px',
  marginLeft: '-8px',
  padding: '8px',
  boxSizing: 'content-box',
}

const POPUP_SX = {
  marginLeft: SPOTLIGHT_SX.marginLeft,
}

const TopicHeader = ({
  name,
  description,
  coverImageUrl,
  isCompleted = false,
  inCourse,
  onToggleInCourse,
}) => {
  return (
    <TopicInfo
      name={name}
      description={description}
      coverImageUrl={coverImageUrl}
    >
      {!isCompleted && (
        <Box mt="3x">
          <CoachMark
            name="coach_mark:add_topic_to_my_course"
            title={t('Bookmark Topics')}
            description={t(
              'Add and remove topics you want to learn to your Course here.'
            )}
            align="below"
            spotlightSx={SPOTLIGHT_SX}
            popupSx={POPUP_SX}
          >
            <ToggleButton
              icon="bookmark"
              checked={inCourse}
              labelCheck={t('Add to course')}
              labelUncheck={t('Remove from course')}
              onToggle={onToggleInCourse}
            />
          </CoachMark>
        </Box>
      )}
    </TopicInfo>
  )
}

TopicHeader.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  coverImageUrl: PropTypes.string,
  isCompleted: PropTypes.bool,
  inCourse: PropTypes.bool.isRequired,
  onToggleInCourse: PropTypes.func.isRequired,
}

export default TopicHeader
